import { render, staticRenderFns } from "./Level1.vue?vue&type=template&id=475937cf&"
import script from "./Level1.vue?vue&type=script&lang=js&"
export * from "./Level1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports